var _module_exports = "<div class=\"pr-widget-error\">\n\t<div class='alert-horizontal'>\n\t\t<div class='alert-vertical' translate> \n\t\t\t{{getWidgetError()}}\n\t\t</div> \n\t</div>\n</div>";;
var path = '/app/src/client/components/widget/widget-error/widget-error.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;